import { CircularProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { HelpOutline } from '@material-ui/icons';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { ACTION_TYPES, DECODE_URL_PATH, ENVIRONMENT_tYPE, GROUP_TYPES, URL_PATH } from 'components/common/constants/Constant';
import Footer from 'components/common/footer/Footer';
import Header from 'components/common/header/Header';
import { default as React, useEffect, useState } from 'react';
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchAnnouncementsStart } from 'redux/actions/announcement.action';
import Breadcrumb from '../../components/common/breadcrumb/breadcrumb';
import styles from '../editors/RoadCondition.module.scss';

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
    pageMargin: {
        margin: "0 6%",
        minHeight: '480px'
    },
    marginTop: {
        marginTop: '3%'
    },
    viewButton: {
        marginTop: "15px",
        marginBottom: "-10px"
    },
    button: {
        margin: 0,
        fontSize: '14px',
        color: 'blue',
    },
    rectBox: {
        margin: '3% 0 0!important',
        '& + $rectItem': {
            marginTop: "10px!important"
        }
    },
    rectItem: {
        marginTop: "10px!important",
        width: "100%"
    }
});

const breacrumbItems = [
    {
        label: "Home",
        href: "/"
    },
    {
        label: "Avalanche Announcements",
        href: "/announcements"
    }
];

const Index = props => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const { control, reset } = useForm();
    const { groupType } = useParams();

    useEffect(() => {
        breacrumbItems.splice(2);
        if (!(DECODE_URL_PATH[groupType] && (Object.values(GROUP_TYPES).indexOf(DECODE_URL_PATH[groupType]) !== -1))) {
            history.push('/announcements');

        }
        else {
            dispatch(fetchAnnouncementsStart(groupType));
            breacrumbItems.push({ label: DECODE_URL_PATH[groupType] })
        }

    }, []);
    const announcementsState = useSelector((state) => state.announcements);
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {

        const announcements = [];
        if (announcementsState.announcements && announcementsState.announcements.announcements) {
            let tiles = {};
            announcementsState.announcements.announcements.map((item, index) => {
                tiles[item.announcementType] = [];
                if (item.environment === 'Live') {
                    tiles[item.announcementType].push(item);
                }
            });
            announcementsState.announcements.announcements.map((item, index) => {
                if (item.environment !== 'Live') {
                    tiles[item.announcementType].push(item);
                }
            });
            Object.keys(tiles).map(tile => {
                announcements.push({ "tiles": tiles[tile] });
            })
        }
        if (announcements.length > 0) {
            reset({ announcements: announcements });
        }

    }, [announcementsState.announcements, announcementsState.announcements?.announcements, fields]);
    useEffect(() => {
        if (announcementsState && announcementsState.error) {
            // errorToast(announcementsState.error);
            setIsSubmitted(false);
            const announcements = [{
                tiles: []
            }];
            reset({ announcements: announcements })
            // onSave();
        }
    }, [announcementsState.error]);

    const { fields } = useFieldArray(
        {
            control,
            name: "announcements"
        }
    );

    const errorToast = (toastMessage) => {
        toast.error(toastMessage, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000
        });
    };
    return (
        <div>
            <Header />
            {announcementsState.loading ?
                <div className={" row " + styles.minh40 + " " + styles.loader}><CircularProgress fontSize="large" /></div> : <>
                    <div className={classes.pageMargin}>
                        <Breadcrumb items={breacrumbItems}></Breadcrumb>
                        <a title="Help" className={styles.helpIcon} target="_blank" href={process.env.REACT_APP_BASE_URL + "/help/transport-ivr-messaging-application-help-avalanche-08062021/content/index.html"}>
                            <HelpOutline className="icon" style={{ fontSize: "30px" }}/>
                        </a>
                        <ToastContainer className={styles.toastContainer} />
                        <div>
                            {
                                fields?.map((tiles, i) => {
                                    return (<div key={tiles[i] ? tiles[i].description + "" + i : i + ""}>
                                        <div className={"row " + classes.rectBox}>
                                            <h1>{fields[i] && fields[i].tiles && fields[i].tiles[0] ? fields[i].tiles[0].description : ''}</h1>
                                        </div>
                                        {fields[i].tiles?.map((item, index) => {
                                            return (<div key={item.message + index}>
                                                {(!(item.environment === ENVIRONMENT_tYPE.LIVE && item.message === '')) ?
                                                    <><div className="row">
                                                        <div className={"col col-xs-12 col-md-12 " + classes.viewButton + " " + styles.rightAlign}>
                                                            <Button color="primary" onClick={() => props.history.push('/announcements/' + groupType + '/' + ((item.environment === 'Staging' && item.message && item.message.trim() === '') ? ACTION_TYPES.NEW : ACTION_TYPES.EDIT), { announcement: item })}>{item.message || item.message !== "" ? "View" : "Create new announcement"}</Button>
                                                        </div>
                                                    </div>
                                                        <div className={classes.rectBox + " " + classes.rectItem + " " + (item.environment === ENVIRONMENT_tYPE.LIVE ? styles.leftGreenBackground : styles.leftGreyBackground)} key={item.announcementType + index} style={{ cursor: "pointer" }}>
                                                            <div className={item.environment === ENVIRONMENT_tYPE.LIVE ? styles.leftGreenBorder : styles.leftGreyBorder}>
                                                                <div className={styles.xmlBackupRow} onClick={() => props.history.push('/announcements/' + groupType + '/' + ((item.environment === 'Staging' && item.message && item.message.trim() === '') ? ACTION_TYPES.NEW : ACTION_TYPES.EDIT), { announcement: item })}>
                                                                    <div>
                                                                        <h2>{item.environment === ENVIRONMENT_tYPE.LIVE ? 'Live IVR Message' : 'Staging Message'}</h2>
                                                                    </div>
                                                                    <div className={styles.mr2 + " ml-auto"}>
                                                                        <ArrowForwardIosIcon /> {item.message}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div></> : <></>
                                                }
                                            </div>
                                            )
                                        })}
                                    </div>)
                                })

                            }

                        </div>
                    </div>
                </>}
            <div className={classes.marginTop}>
                <Footer />
            </div>
        </div>
    );
}

export default withRouter(props => <Index {...props} />);